import { render, staticRenderFns } from "./FiBuKontenblaetterSums.vue?vue&type=template&id=439cf23a&"
import script from "./FiBuKontenblaetterSums.vue?vue&type=script&lang=js&"
export * from "./FiBuKontenblaetterSums.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports